import { render, staticRenderFns } from "./document.vue?vue&type=template&id=76ae74de&scoped=true&"
import script from "./document.vue?vue&type=script&lang=js&"
export * from "./document.vue?vue&type=script&lang=js&"
import style0 from "./document.vue?vue&type=style&index=0&id=76ae74de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ae74de",
  null
  
)

export default component.exports